import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Popup } from 'devextreme-react/popup';
import { Spinner } from '@core/components';
import { XUserInteraction } from '@core/utils';

// components
import UserPanelTitle from './UserPanelTitle/UserPanelTitle';

const endpoint = 'sysinfo/getconnectionstring';

export const getCs = () => axios.get(endpoint);

export const handleOnShowing = (e, setVisible) => {
  const saveButton = e.component._$content[0].querySelector('.dx-icon-close');
  const setVisibleFalse = () => {
    setVisible(false);
  };

  saveButton.onclick = setVisibleFalse;
};

const UserPanelPopup = ({ visible, setVisible }: any) => {
  const [connectionString, setConnectionString] = useState('');

  useEffect(() => {
    if (visible && connectionString === '') {
      getCs()
        .then(({ data }) => setConnectionString(data))
        .catch(XUserInteraction.notifyError);
    }
  }, [visible, connectionString]);

  return (
    <Popup
      visible={visible}
      onShowing={(e) => handleOnShowing(e, setVisible)}
      titleComponent={UserPanelTitle}
      maxWidth={350}
      maxHeight={250}
    >
      <div style={{ position: 'relative', height: '100%' }}>
        {connectionString !== '' ? (
          <>
            <div>API: {globalThis.config.authApiUrl}</div>
            <div>CS: {connectionString}</div>
          </>
        ) : (
          <Spinner />
        )}
      </div>
    </Popup>
  );
};

export default UserPanelPopup;
